export default "__VITE_ASSET__095546a4__"